import $ from 'jquery';
import 'slick-carousel';
import Loop from './Loop';
import Parallax from './Parallax';
import BackgroundImage from './BackgroundImage';
import CarouselControls from './PlayPauseControls';

const container = '.view-content';
const slide = '.views-row';
const settings = {
  speed: 500,
  fade: true,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: false,
  dots: false,
  pauseOnFocus: false,
  pauseOnHover: false,
};

export default class Banner {
  constructor(element) {
    this.element = element;
    this.settings = settings;
    this.$element = $(element);
    this.preprocess();

    if (this.$element.find(`${container} ${slide}`).length > 1) {
      this.$carousel = this.addCarousel();
      this.$loop = this.addLoop();
      this.controls = this.addControls();
    }

    this.ready();
  }

  addCarousel() {
    return this.$element.find(container).slick(this.settings);
  }

  addLoop() {
    return new Loop(this.$carousel, this.settings);
  }

  addControls() {
    return new CarouselControls(this.$carousel);
  }

  preprocess() {
    this.$element.find('.node').each((a, node) => {
      // Add parallax background image.
      $('.node-upper-image .field-image', node).each((b, image) => {
        node.BackgroundImage = new BackgroundImage(image);
        node.Parallax = new Parallax(image);
      });
    });
  }

  ready() {
    return this.$element.addClass('ready');
  }
}
